import axios from "../axios";
import endpoints from "@/endpoints";
import store from "@/store/index";

const { VUE_APP_PREPR_API } = process.env;

const ax = axios.create();

export async function useClassicalContent(slug) {
    const res = await ax({
        url: VUE_APP_PREPR_API,
        method: "post",
        data: {
            query: `
            {
                ClassicalContentItem (slug: "${slug}") {
                  _id
                  title
                  _slug
                  content {
                   _id
                   heading
                   text
                   main_image {
                    _id
                    url
                   }
                   sub_images {
                    _id
                    url
                   }
                   plain_text
                  }
                 }
            }
      `,
        },
    });
    return res?.data?.data?.ClassicalContentItem?.content;
}

export function getRequiredContent(required) {
    return Promise.all(required.map((t) => useClassicalContent(t)));
}

const colours = {
    roman: "#B91C1C",
    greek: "#0369A1",
    egypt: "#A16207",
    egyptian: "#b45309",
};

export function getClassicalColour(type) {
    const colour = colours[type];
    if (!colour) {
        throw new Error(`No matching type: ${type}`);
    }
    return colour;
}

export async function getClassicalResult() {
    try {
        const { data } = await axios.get(
            endpoints.classicalResult(store.getters.profile["profile"].barcode)
        );
        return (data && data.results) ? JSON.parse(data.results) : {};
    } catch (e) {
        console.error(e);
        throw new Error(e);
    }
}
